var _g, _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _path5, _mask, _ellipse, _path6, _circle4, _path7, _path8, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _path9, _path0, _circle13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 319,
    viewBox: "0 0 344 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33,
    filter: "url(#filter0_f_302_12047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.239 110.947C145.398 143.14 154.633 197.229 152.702 232.345",
    stroke: "url(#paint0_linear_302_12047)",
    strokeWidth: 6.90677,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.219 65.1936C196.256 64.716 170.648 69.7797 147.924 93.8553M199.762 105.741C195.046 104.117 182.882 101.637 171.95 104.708M180.707 137.632C173.992 127.723 166.679 120.932 154.61 116.459M75.0629 174.299C77.8181 163.696 88.6582 139.42 109.978 127.141M59.0248 126.182C65.1238 118.736 84.0509 104.704 110.968 108.151M72.209 85.5465C84.2364 84.6251 94.8257 85.5821 105.855 89.8556M137.935 51.8485C130.544 62.2792 126.312 78.7031 127.832 87.6136M171.299 46.4076C162.63 52.2833 153.161 62.3148 149.886 68.1494",
    stroke: "url(#paint1_radial_302_12047)",
    strokeWidth: 12.0869,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.182,
    cy: 108.148,
    r: 9.52171,
    transform: "rotate(24.3083 132.182 108.148)",
    fill: "#A8AEC8"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.163,
    cy: 234.532,
    r: 71,
    fill: "#EFEFFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2126,
    cy: 80.2126,
    r: 71.5229,
    transform: "matrix(1 0 0 -1 93 318.163)",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.227 224.421C166.652 227.868 162.063 232.923 156.513 232.107C153.213 231.621 149.699 231.36 146.053 231.36C142.409 231.36 138.897 231.621 135.598 232.106C130.049 232.921 125.46 227.867 129.885 224.42C134.22 221.043 139.872 219 146.055 219C152.239 219 157.892 221.043 162.227 224.421ZM146.178 263.495C146.136 263.496 146.094 263.496 146.053 263.496C146.014 263.496 145.975 263.496 145.936 263.495C145.976 263.496 146.016 263.496 146.055 263.496C146.096 263.496 146.137 263.496 146.178 263.495Z",
    fill: "#A0A6C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.116 224.421C220.541 227.868 215.951 232.923 210.402 232.107C207.101 231.621 203.587 231.36 199.942 231.36C196.298 231.36 192.785 231.621 189.487 232.106C183.937 232.921 179.349 227.867 183.774 224.42C188.108 221.043 193.761 219 199.944 219C206.128 219 211.781 221.043 216.116 224.421ZM200.066 263.495C200.025 263.496 199.983 263.496 199.942 263.496C199.903 263.496 199.864 263.496 199.825 263.495C199.864 263.496 199.904 263.496 199.944 263.496C199.985 263.496 200.025 263.496 200.066 263.495Z",
    fill: "#A0A6C3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 159.844 157.737)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.213 137.685C173.213 164.422 173.213 171.107 173.213 171.107",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.426 251.319C253.426 229.929 253.426 224.582 253.426 224.582",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93 251.319C93 229.929 93 224.582 93 224.582",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_302_12047",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 17.5,
    rx: 13.5,
    ry: 17.5,
    transform: "matrix(1 0 0 -1 160 282)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 17.5,
    rx: 13.5,
    ry: 17.5,
    transform: "matrix(1 0 0 -1 160 282)",
    fill: "#A0A6C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.621 264.5C169.621 263.181 169.189 262.617 169.285 262.741C169.355 262.831 169.678 263.219 170.399 263.614C171.164 264.033 172.243 264.379 173.5 264.379V229.621C194.479 229.621 204.379 249.7 204.379 264.5H169.621ZM173.5 264.379C174.757 264.379 175.836 264.033 176.601 263.614C177.322 263.219 177.645 262.831 177.715 262.741C177.811 262.617 177.379 263.181 177.379 264.5H142.621C142.621 249.7 152.521 229.621 173.5 229.621V264.379ZM177.379 264.5C177.379 265.819 177.811 266.383 177.715 266.259C177.645 266.169 177.322 265.781 176.601 265.386C175.836 264.967 174.757 264.621 173.5 264.621V299.379C152.521 299.379 142.621 279.3 142.621 264.5H177.379ZM173.5 264.621C172.243 264.621 171.164 264.967 170.399 265.386C169.678 265.781 169.355 266.169 169.285 266.259C169.189 266.383 169.621 265.819 169.621 264.5H204.379C204.379 279.3 194.479 299.379 173.5 299.379V264.621Z",
    fill: "#A0A6C4",
    mask: "url(#path-12-inside-1_302_12047)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 244,
    r: 6,
    fill: "#DEDEF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.12 160.185C260.433 178.871 236.872 213.807 227.122 238.994",
    stroke: "url(#paint2_linear_302_12047)",
    strokeWidth: 6.49971,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.508 105.093C249.632 107.908 265.953 119.547 274.246 143.58M234.209 135.512C238.023 135.866 247.32 137.975 254 143.58M237.463 163.854C245.295 159.043 252.561 156.602 262.421 157.286M299.808 222.913C301.232 214.622 301.32 194.205 290.281 178.871M326.244 194.308C324.33 187.168 315.519 171.364 295.591 165.268M329.863 161.701C321.736 157.254 314.023 154.576 304.953 154.08M294.516 117.339C296.391 126.975 294.161 139.808 290.281 145.564M272.886 102.984C277.096 109.837 280.551 119.851 280.999 124.97",
    stroke: "url(#paint3_radial_302_12047)",
    strokeWidth: 11.3745,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.31217,
    cy: 7.31217,
    r: 7.31217,
    transform: "matrix(-1 0 0 1 288.058 151.247)",
    fill: "#A8AEC8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 73,
    r: 6,
    fill: "#DEDEF8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 279,
    r: 6,
    fill: "#D7D7ED"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 241 157)",
    fill: "#DCDCF0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 309 291)",
    fill: "#E2E2F8"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 200 151)",
    fill: "#E2E2F8"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 29 302)",
    fill: "#E2E2F8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 241 315)",
    fill: "#E2E2F8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 36 112)",
    fill: "#E2E2F8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 279 267)",
    fill: "#E5E5F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 183.5C52 195 66.5 216.5 72.5 232",
    stroke: "url(#paint4_linear_302_12047)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0317 149.596C58.6476 151.328 48.6035 158.491 43.5 173.281M68.1389 168.316C65.7919 168.534 60.0703 169.832 55.9592 173.281M66.1364 185.758C61.3165 182.797 56.8452 181.295 50.777 181.716M27.7683 222.104C26.8921 217.001 26.8383 204.436 33.6319 195M11.4996 204.5C12.6777 200.106 18.0999 190.38 30.3638 186.628M9.27255 184.433C14.2736 181.696 19.0206 180.048 24.6025 179.743M31.0252 157.132C29.8714 163.063 31.2436 170.96 33.6319 174.502M44.337 148.298C41.7459 152.515 39.6194 158.678 39.3438 161.828",
    stroke: "url(#paint5_radial_302_12047)",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 182.5,
    r: 4.5,
    fill: "#A8AEC8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_302_12047",
    x: 43.9491,
    y: 31.3314,
    width: 177.346,
    height: 213.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51617,
    result: "effect1_foregroundBlur_302_12047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_12047",
    x1: 130.782,
    y1: 108.677,
    x2: 153.364,
    y2: 216.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A6C3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_302_12047",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.291 109.67) rotate(99.55) scale(91.5387 85.2498)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190425,
    stopColor: "#A0A6C3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A6C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_302_12047",
    x1: 281.558,
    y1: 159.372,
    x2: 231.701,
    y2: 227.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A6C3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_302_12047",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(279.488 159.274) rotate(104.598) scale(67.4018 62.7712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225859,
    stopColor: "#A0A6C3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A6C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_302_12047",
    x1: 39,
    y1: 183,
    x2: 69.6824,
    y2: 225.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A6C3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_302_12047",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.274 182.94) rotate(75.2416) scale(43.2615 40.2894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180958,
    stopColor: "#A0A6C3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A6C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage5);
export default __webpack_public_path__ + "static/media/emptyImage5.29bf0a80cb8702c134c3a3f2eb3facc0.svg";
export { ForwardRef as ReactComponent };